import React from "react";
import HtmlDefault from "common/fragments/HtmlDefault";
import HeadingView from "common/views/heading/Heading.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { Fragment } from "core/components/FragmentProvider";
import { Article } from "./entities";
import * as articleActions from "./arcticleActions";
import Label from "core/components/label/Label";
import PageLinkView from "common/views/pageLink/PageLink.view";
import constants from "../constants";

interface IArticleEditFragmentProps {
	article: Article;
	onChange: (article: Article) => void;
	uiSchema: any;
	actions?: typeof articleActions;
	contributorDisplay?: JSX.Element;
	attachmentDisplay?: JSX.Element;
	config?: any;
}

export const description: Fragment<IArticleEditFragmentProps> = {
	name: "Description",
	enabled: (props) => !!props.article.description,
	component: (props) => (
		<TypographyView viewKey="article.description">
			<HtmlDefault html={props.article.description} />
		</TypographyView>
	),
};

export const title: Fragment<IArticleEditFragmentProps> = {
	name: "Title",
	component: (props) => (
		<HeadingView viewKey="article.title">{props.article.name}</HeadingView>
	),
};

export const categories: Fragment<IArticleEditFragmentProps> = {
	name: "Categories",
	enabled: (props) =>
		!!props.article.categories && props.article.categories.length > 0,
	component: (props) => (
		<div>
			<HeadingView viewKey="property.title">
				<Label k="kb.categories" v="Categories" />
			</HeadingView>
			{props.article.categories.reduce((lst, c, i) => {
				if (i > 0) {
					lst.push(
						<React.Fragment key={c.id + "-separator"}>
							{", "}
						</React.Fragment>
					);
				}

				lst.push(
					<PageLinkView
						key={c.id}
						viewKey="category.link"
						preserveParams={true}
						params={{
							[constants.PARAM_CATEGORY_ID]: c.id,
						}}
					>
						{c.name}
					</PageLinkView>
				);

				return lst;
			}, [])}
		</div>
	),
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/articleFragments.tsx